import React, { useContext, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import Global from '../../../../store/global-selectors';
import { id } from '../../../../filters/options/created-date';
import DateRangePicker from '../../../components/date-range-picker';

import { AdvancedSearchShipmentContext } from '../../context';
import messages from '../messages';

import baseStyle from '../../../style.module.less';

const OrderDateFilter = () => {
  const dateFormat = useSelector(Global.selectUserUserDateFormat);
  const { filters, updateFilter } = useContext(AdvancedSearchShipmentContext);
  const { value: shipDates = {} } = filters.find((filter) => filter.id === id) || {};

  const updateDateFilter = useCallback(
    (dates) => {
      updateFilter(id, dates);
    },
    [updateFilter],
  );

  const { from = null, to = null } = shipDates;

  return (
    <span className={baseStyle.filterInput}>
      <label className={baseStyle.filterLabel}>
        <FormattedMessage {...messages.createdDate} />
      </label>
      <DateRangePicker dateFormat={dateFormat} from={from} setDates={updateDateFilter} to={to} />
    </span>
  );
};

export default OrderDateFilter;
